<div class="simulator-container">
  @if (viewState(); as viewState) {
    @if (viewState.status === 'initial') {
      <button (click)="simulate()">Generar simulación de prueba</button>
    } @else if (viewState.status === 'loading') {
      <div class="loading">Generando...</div>
    } @else if (viewState.status === 'error') {
      <div class="error">Ocurrió un error: {{ viewState.error }}</div>
      <div><button (click)="simulate()">Intentar nuevamente</button></div>
    } @else {
      <div class="simulation-result">
        <p><strong>ID:</strong> {{ viewState.value.id }}</p>
        <p><strong>Producto:</strong> {{ viewState.value.product }}</p>
        <p><strong>Tasa:</strong> {{ viewState.value.rate | percent:'1.2-2' }}</p>
        <p><strong>Pago mensual:</strong> {{ viewState.value.monthlyPayment | currency:'MXN':'symbol-narrow':'1.2-2' }}</p>
        <button (click)="simulate()">Generar nueva simulación</button>
      </div>
    }
  }
</div>